import { useState, useEffect } from "react";
import { 
  subscribeToAgendas, 
  addAgenda, 
  updateAgenda, 
  deleteAgenda,
  uploadAgendaAttachment,
  deleteAgendaAttachment
} from "../services/agendasService";

export function useAgendas() {
  const [agendas, setAgendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToAgendas((data, err) => {
        if (err) {
          setError("Failed to load agendas.");
        } else {
          setAgendas(data);
          setError("");
        }
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize agendas subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddAgenda = async (data) => {
    try {
      setError("");
      return await addAgenda(data);
    } catch (err) {
      console.error("Error adding agenda:", err);
      setError(err.message || "Failed to add agenda.");
      throw err;
    }
  };

  const handleUpdateAgenda = async (id, data) => {
    try {
      setError("");
      await updateAgenda(id, data);
    } catch (err) {
      console.error("Error updating agenda:", err);
      setError(err.message || "Failed to update agenda.");
      throw err;
    }
  };

  const handleDeleteAgenda = async (id) => {
    try {
      setError("");
      await deleteAgenda(id);
    } catch (err) {
      console.error("Error deleting agenda:", err);
      setError(err.message || "Failed to delete agenda.");
      throw err;
    }
  };

  return {
    agendas,
    loading,
    error,
    addAgenda: handleAddAgenda,
    updateAgenda: handleUpdateAgenda,
    deleteAgenda: handleDeleteAgenda,
    uploadAgendaAttachment,
    deleteAgendaAttachment
  };
}
